/* zm-option-price-badges.js
   ZM • Option Price Badges • Rewrite Stable v1.2

   目标：
   - 首屏默认进入页面时，非 Digital 尺寸立即显示加价
   - Digital File / Digital Download 自己不显示 badge
   - 基准价固定仍然使用 Digital
   - 尺寸 badge 的显示价格，优先使用 Print 对应尺寸价格
   - 不再使用当前默认 Black Canvas 那套价格来显示尺寸 badge
*/

(() => {
  if (window.__ZM_OPTION_PRICE_BADGES_REWRITE_V1_2__) return;
  window.__ZM_OPTION_PRICE_BADGES_REWRITE_V1_2__ = true;

  const CFG = {
    BADGE_CLASS: 'zm-price-badge',
    TARGET_IMG_SELECTOR: '.color-swatch__image',
    POLL_MS: 180,
    POLL_TIMEOUT_MS: 12000,
    OBSERVE_DEBOUNCE_MS: 160,
    DIGITAL_KEYWORDS: ['digital', 'download', 'file'],

    // 这里填你“Print”这类材质的关键词
    PRINT_KEYWORDS: ['print', 'paper', 'poster']
  };

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const debounce = (fn, ms) => {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  const norm = (s) =>
    String(s || '')
      .trim()
      .replace(/\u00A0/g, ' ')
      .replace(/[″”“]/g, '"')
      .replace(/[×]/g, 'x')
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  const isDigitalSize = (val) => {
    const t = norm(val);
    return CFG.DIGITAL_KEYWORDS.some(k => t.includes(k));
  };

  const isPrintLike = (val) => {
    const t = norm(val);
    return CFG.PRINT_KEYWORDS.some(k => t.includes(k));
  };

  const getHandleFromUrl = () => {
    const m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  };

  // -----------------------------
  // Product data
  // -----------------------------
  let PRODUCT = null;
  let VARIANTS = [];
  let OPTIONS = [];
  let SIZE_INDEX = -1;
  let SIZE_NAME = null;

  async function loadProductJson() {
    const handle = getHandleFromUrl();
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function detectSizeOption() {
    let idx = OPTIONS.findIndex(o => norm(o?.name).includes('size'));
    if (idx >= 0) {
      SIZE_INDEX = idx;
      SIZE_NAME = OPTIONS[idx].name;
      return true;
    }

    const radios = $$(`.product-form__input--swatches input[type="radio"][name]`);
    const hit = radios.find(r => norm(r.name).includes('size'));
    if (hit) {
      const domName = hit.name;
      idx = OPTIONS.findIndex(o => o && o.name === domName);
      if (idx >= 0) {
        SIZE_INDEX = idx;
        SIZE_NAME = domName;
        return true;
      }
    }

    return false;
  }

  // -----------------------------
  // Variant helpers
  // -----------------------------
  function getCurrentVariantId() {
    const input =
      $('form[action*="/cart/add"] input[name="id"]') ||
      $('form[action="/cart/add"] input[name="id"]') ||
      $('input[name="id"]');

    return input ? String(input.value || '').trim() : '';
  }

  function getCurrentVariant() {
    const id = getCurrentVariantId();
    if (!id) return VARIANTS.find(v => v && v.available) || VARIANTS[0] || null;
    return VARIANTS.find(v => String(v.id) === id) || VARIANTS[0] || null;
  }

  function getReferenceNonSizeOptions() {
    const current = getCurrentVariant();
    if (!current || !Array.isArray(current.options)) return [];

    return current.options
      .map((val, idx) => ({ index: idx, value: val }))
      .filter(item => item.index !== SIZE_INDEX);
  }

  function variantMatchesNonSizeOptions(variant, refOptions) {
    if (!variant || !Array.isArray(variant.options)) return false;
    return refOptions.every(item => norm(variant.options[item.index]) === norm(item.value));
  }

  function findVariantBySize(sizeValue, refOptions) {
    let found = VARIANTS.find(v => {
      if (!v || !Array.isArray(v.options)) return false;
      if (norm(v.options[SIZE_INDEX]) !== norm(sizeValue)) return false;
      return variantMatchesNonSizeOptions(v, refOptions);
    });

    if (found) return found;

    found = VARIANTS.find(v => {
      if (!v || !Array.isArray(v.options)) return false;
      return norm(v.options[SIZE_INDEX]) === norm(sizeValue);
    });

    return found || null;
  }

  // ✅ 新增：优先找“Print + 对应 size”的 variant
  function findPrintVariantBySize(sizeValue) {
    // 先找：该 variant 的 size 匹配，并且非 size 选项里包含 print/paper/poster
    let found = VARIANTS.find(v => {
      if (!v || !Array.isArray(v.options)) return false;
      if (norm(v.options[SIZE_INDEX]) !== norm(sizeValue)) return false;

      return v.options.some((optVal, idx) => {
        if (idx === SIZE_INDEX) return false;
        return isPrintLike(optVal);
      });
    });

    if (found) return found;

    return null;
  }

  function findDigitalBaselineVariant(refOptions) {
    let found = VARIANTS.find(v => {
      if (!v || !Array.isArray(v.options)) return false;
      if (!isDigitalSize(v.options[SIZE_INDEX])) return false;
      return variantMatchesNonSizeOptions(v, refOptions);
    });

    if (found) return found;

    found = VARIANTS.find(v => {
      if (!v || !Array.isArray(v.options)) return false;
      return isDigitalSize(v.options[SIZE_INDEX]);
    });

    return found || null;
  }

  // -----------------------------
  // DOM helpers
  // -----------------------------
  function findSizeWrap() {
    const blocks = $$(`.product-form__input--swatches, .product-form__input`);
    for (const block of blocks) {
      const hit = SIZE_NAME
        ? $(`input[type="radio"][name="${CSS.escape(SIZE_NAME)}"]`, block)
        : null;
      if (hit) return block;
    }
    return null;
  }

  function getSizeSwatchItems(wrap) {
    if (!wrap || !SIZE_NAME) return [];
    const items = $$('.color-swatch', wrap);
    return items.filter(item => !!$(`input[type="radio"][name="${CSS.escape(SIZE_NAME)}"]`, item));
  }

  function ensureBadge(host) {
    if (!host) return null;

    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }

    let badge = host.querySelector(`.${CFG.BADGE_CLASS}`);
    if (!badge) {
      badge = document.createElement('div');
      badge.className = CFG.BADGE_CLASS;
      badge.style.pointerEvents = 'none';
      host.appendChild(badge);
    }
    return badge;
  }

  function setBadge(badge, visible, text = '') {
    if (!badge) return;
    if (!visible) {
      badge.style.display = 'none';
      badge.textContent = '';
      return;
    }
    badge.style.display = '';
    if (badge.textContent !== text) badge.textContent = text;
  }

  // -----------------------------
  // Core render
  // -----------------------------
  function renderBadges() {
    if (!PRODUCT || SIZE_INDEX < 0 || !SIZE_NAME) return;

    const wrap = findSizeWrap();
    if (!wrap) return;

    const items = getSizeSwatchItems(wrap);
    if (!items.length) return;

    const refOptions = getReferenceNonSizeOptions();

    // ✅ 基准价仍然是 Digital
    const digitalVariant = findDigitalBaselineVariant(refOptions);
    const digitalPrice =
      digitalVariant && typeof digitalVariant.price === 'number'
        ? digitalVariant.price
        : null;

    items.forEach(item => {
      const input = $(`input[type="radio"][name="${CSS.escape(SIZE_NAME)}"]`, item);
      if (!input) return;

      const sizeVal = input.value;
      const host = $(CFG.TARGET_IMG_SELECTOR, item) || item;
      const badge = ensureBadge(host);
      if (!badge) return;

      // Digital 自己永远不显示
      if (isDigitalSize(sizeVal)) {
        setBadge(badge, false);
        return;
      }

      // ✅ 关键改动：
      // 先找 Print + 当前 size 的价格
      // 找不到再 fallback 到原来的当前材质 size
      const printVariant = findPrintVariantBySize(sizeVal);
      const matchedVariant = printVariant || findVariantBySize(sizeVal, refOptions);

      if (!matchedVariant || typeof matchedVariant.price !== 'number') {
        setBadge(badge, false);
        return;
      }

      if (typeof digitalPrice !== 'number') {
        setBadge(badge, false);
        return;
      }

      const diff = matchedVariant.price - digitalPrice;

      if (diff <= 0) {
        setBadge(badge, false);
        return;
      }

      setBadge(badge, true, `+${money(diff)}`);
    });
  }

  const renderBurst = () => {
    try { renderBadges(); } catch (e) {}

    setTimeout(() => {
      try { renderBadges(); } catch (e) {}
    }, 180);

    setTimeout(() => {
      try { renderBadges(); } catch (e) {}
    }, 450);

    setTimeout(() => {
      try { renderBadges(); } catch (e) {}
    }, 900);
  };

  const scheduleRender = debounce(() => {
    requestAnimationFrame(() => {
      renderBurst();
    });
  }, CFG.OBSERVE_DEBOUNCE_MS);

  function attachEvents() {
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.type === 'radio') {
        scheduleRender();
      }
    }, true);
  }

  function attachObserver() {
    const root =
      $('variant-selects') ||
      $('product-form') ||
      $('.main-product__info-container') ||
      $('.step-flow-root') ||
      document.body;

    const mo = new MutationObserver(() => {
      scheduleRender();
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  async function init() {
    PRODUCT = await loadProductJson();
    if (!PRODUCT) return;

    OPTIONS = Array.isArray(PRODUCT.options) ? PRODUCT.options : [];
    VARIANTS = Array.isArray(PRODUCT.variants) ? PRODUCT.variants : [];

    if (!detectSizeOption()) return;

    const start = Date.now();
    const timer = setInterval(() => {
      const wrap = findSizeWrap();
      const ok = !!wrap && getSizeSwatchItems(wrap).length > 0;

      if (ok) {
        clearInterval(timer);
        renderBurst();
      } else if (Date.now() - start > CFG.POLL_TIMEOUT_MS) {
        clearInterval(timer);
      }
    }, CFG.POLL_MS);

    attachEvents();
    attachObserver();

    window.addEventListener('load', () => {
      renderBurst();
    });

    setTimeout(() => {
      renderBurst();
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();